import { useNavigate } from "react-router-dom";
import errorIcon from "../../../public/images/svg/errorIcon.svg";
import StyledHeader from "../../components/StyledHeader";

import {
  NOT_FOUND_DESCRIPTION_404,
  NOT_FOUND_TITLE_404,
  NOT_FOUND_TITLE_404_TWO,
} from "@/constants";
import { StyledButton } from "@/components/Button";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const buttonText = "Go to HomePage";
  const buttonStyle = "bg-CostcoAction px-4 py-6";
  return (
    <div>
      <StyledHeader />
      <div className="pt-12 bg-gray-100 text-blue-600 h-screen justify-center text-center ">
        <div className="mx-auto">
          <div className="tracking-widest mt-4 text-CostcoAction font-Helvetica">
            <div className="flex justify-center items-center pt-28 pb-12">
              <img src={errorIcon} alt="errorIcon" />
            </div>
            <div className="text-5xl block">
              <p>{NOT_FOUND_TITLE_404}</p>
              <p>{NOT_FOUND_DESCRIPTION_404}</p>
            </div>
            <div className="ext-xl py-8">{NOT_FOUND_TITLE_404_TWO}</div>
          </div>
          <div className="w-full items-center justify-center flex flex-col">
            <StyledButton
              text={buttonText}
              additionalClassName={buttonStyle}
              onClick={() => {
                navigate("/");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
